var DurationWatchedListener = require("./DurationWatchedListener.js");

var $ = jQuery;
var player;
var videoID;
var timeListener;
var interval;

var forcePause = false;

function _pause() {
	if (player) {
		forcePause = true;
		player.pause(true);
	}
}

function forcePauseIfNecessary() {
	forcePause && _pause();
}

function firstPopup() {
	$(".full-access__js").addClass("full-access__hidden");
	$(".full-access__js-first").removeClass("full-access__hidden");
}

function secondPopup() {
	$(".full-access__js").addClass("full-access__hidden");
	$(".full-access__js-second").removeClass("full-access__hidden");
}

function finalPopup() {
	if (player) {
		player.pause();
		player.stop();
		player.setMute(true);
		setTimeout(function(){
			player.remove();
		},2000);
	}
	if (interval) {
		clearInterval(interval);
	}
	$(".full-access__js").addClass("full-access__hidden");
	$(".full-access__js-final").removeClass("full-access__hidden");
}

var breakpoints = [{
	id:"finalBreakpoint",
	single:20.5 * 60,
	total:30.5 * 60,
	handler:finalPopup
},{
	id:"secondBreakpoint",
	single:19.5 * 60,
	total:30 * 60,
	handler:secondPopup
},{
	id:"firstBreakpoint",
	single:10 * 60,
	total:19 * 60,
	handler:firstPopup
}];

var breakpointsDone = new Array(breakpoints.length);

function getExceededBreakpoint(data) {
	var total = 0;
	if (!data) {
		data = localStorage.getItem("TotalVideos.Data");
		if (data) {
			try {
				data = JSON.parse(data);
			} catch(e) {
				data = {};
			}
		} else {
			data = {};
		}
	}
	for (var id in data) {
		if (data.hasOwnProperty(id)) {
			total += data[id];
		}
	}
	for (var i = 0, len = breakpoints.length; i < len; ++i) {
		if (total > breakpoints[i].total) {
			return i;
		} else {
			for (var id in data) {
				if (data.hasOwnProperty(id) && data[id] > breakpoints[i].single) {
					return i;
				}
			}
		}
	}
	return null;
}

var lastTimeWatched = 0;
function check() {
	var data = localStorage.getItem("TotalVideos.Data");
	if (data) {
		try {
			data = JSON.parse(data);
		} catch(e) {
			data = {};
		}
	} else {
		data = {};
	}
	if (!data.hasOwnProperty(videoId)) {
		data[videoId] = 0;
	}
	var timeWatched = timeListener.getDurationWatched();
	data[videoId] += timeWatched - lastTimeWatched;
	localStorage.setItem("TotalVideos.Data",JSON.stringify(data));
	var exceededBreakpoint = getExceededBreakpoint(data);
	if (exceededBreakpoint !== null && !breakpointsDone[exceededBreakpoint]) {
		breakpointsDone[exceededBreakpoint] = true;
		breakpoints[exceededBreakpoint].handler();
	}
	lastTimeWatched = timeWatched;
}

function onPlayingMainVideo(_player) {
	this.removeListener(onPlayingMainVideo);
	player = _player;
	player.onPlay(forcePauseIfNecessary);
	videoId = JS_VARS.VideoID;
	timeListener = new DurationWatchedListener(player);
	var now = (new Date()).getTime();
	var dateAdded = localStorage.getItem("TotalVideos.DateAdded");
	if (!dateAdded) {
		localStorage.setItem("TotalVideos.DateAdded",now);
		dateAdded = now;
	} else {
		dateAdded = parseInt(dateAdded,10);
	}
	if ((now - dateAdded) > 30*24*60*60*1000 /* 30 days */) {
		localStorage.setItem("TotalVideos.DateAdded",now);
		localStorage.removeItem("TotalVideos.Data");
		localStorage.removeItem("TotalVideos.BreakpointsExceeded");
	}
	check();
	interval = setInterval(check,5000);
}

var done = false;

function go(mainPlayer) {
	if (!done) {
		done = true;
		if (
			!JS_VARS.IsLoggedIn
			&& (typeof window.localStorage !== "undefined")
			&& window.localStorage
			&& (typeof JSON !== "undefined")
			&& (typeof JSON.parse === "function")
			&& (typeof JSON.stringify === "function")
		) {
			$(document).on("click",".full-access--play__js",function(){
				forcePause = false;
				if (player) {
					player.play(true);
				}
				$(".full-access__js").addClass("full-access__hidden");
			});
			mainPlayer.onPlayingMainVideo.addListener(onPlayingMainVideo);
		}
	}
}

module.exports = go;